<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Документ
        .form-elem__main
          .achievements
            .achievements__list.achievements-list
              .achievements-list__item
                .achievement(
                v-for="(award, index) in awards"
                )
                  .attached-file
                    a.button(
                      @click.prevent="onShowPortfolio(index)"
                    )
                      .button__text {{ award.title }}
</template>

<script>
import Modal from "../../../components/modal/modal";
export default {
  name: "request-portfolio",
  components: { Modal },
  props: {
    awards: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModal: false,
      modalData: {},
    };
  },
  methods: {
    onShowPortfolio(index) {
      this.$emit("onShowPortfolioModal", index);
    },
  },
};
</script>
